import React, { useRef } from "react";

import { CustomerPortalMilestoneStep } from "Models/customer.portal";

import {
  CustomerPortalMilestones,
  CustomerPortalMilestonesHandles,
} from "../../CustomerPortalMilestones";
import { CustomerPortalSelectionMenu } from "../../CustomerPortalSelectionMenu";
import { useIsMobileCustomerPortal } from "../../useIsMobileCustomerPortal";
import StepLineComponent from "../StepLine";
import { Steps } from "../styled";
import { SubHeaderContainer } from "./styles";

interface ISubHeader {
  milestonesSteps?: CustomerPortalMilestoneStep[];
  onOpenShipment: (shipmentId: number) => void;
}

export const SubHeader = ({ milestonesSteps, onOpenShipment }: ISubHeader) => {
  const { isMobileDevice } = useIsMobileCustomerPortal();
  const milestoneRef = useRef<CustomerPortalMilestonesHandles>(null);

  return (
    <SubHeaderContainer>
      <CustomerPortalSelectionMenu />

      <Steps>
        <StepLineComponent
          onOpenAllSteps={() => milestoneRef.current?.open()}
          milestonesSteps={milestonesSteps}
          isMobileDevice={isMobileDevice}
        />
      </Steps>
      <CustomerPortalMilestones
        onOpenShipment={(shipmentId) => onOpenShipment(shipmentId)}
        milestonesSteps={milestonesSteps}
        isMobileDevice={isMobileDevice}
        ref={milestoneRef}
      />
    </SubHeaderContainer>
  );
};
